import { FormLabel } from "@/components/ui/form"
import { LoginMethodName } from "@/constants/credentials/credential"

export const RadioInputField = ({
  label,
  descriptionLabel,
  value,
  isChecked,
  onChange,
  isDisabled = false
}: {
  label: string,
  descriptionLabel?: string
  value: string,
  isChecked: boolean,
  onChange: (value: React.SetStateAction<LoginMethodName>) => void,
  isDisabled?: boolean
}) => (
  <div className="flex flex-row items-start mr-2 mt-1">
    <input
      type="radio"
      disabled={isDisabled}
      className="aspect-square cursor-pointer mr-2 h-4 w-4 rounded-full border border-accent text-accent ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed"
      id={value}
      value={value}
      checked={isChecked}
      onChange={() => onChange(value as LoginMethodName)}
    />
    <div className="flex flex-col items-start mb-4">
      <FormLabel
        htmlFor={value}
        className={`font-medium cursor-pointer text-base leading-4 h-4 -mt-1 ${isDisabled && 'text-secondary'}`}
      >
        {label}
      </FormLabel>
      {descriptionLabel ? (
        <label htmlFor={value} className="text-secondary font-normal leading-4 text-sm mt-2 text-left">
          {descriptionLabel}
        </label>
      ) : null}
    </div>
  </div>
)
